export const subfunctionFieldHelp = (label: string, kind: string, readonly: boolean): string => {
  const name=String(label||'此项').replace(/[：:*\s]+$/g,'')
  if(readonly) return `“${name}”当前只读或不可用，请先核对显示内容，不要把它当作可编辑入口。`
  if(/password/i.test(kind)||/密码/.test(name))return `按本页提示设置“${name}”。引导不会读取、填写或保存密码；是否必填以当前页面提示为准。`
  if(/手机|电话/.test(name))return `填写或核对“${name}”，注意号码是否属于当前办理对象；可见内容仍受账号权限控制。`
  if(/金额|余额|价格|费用|退款/.test(name))return `逐项核对“${name}”的金额及单位，实际提交前再次确认对象和金额。引导不会办理支付、退款或保存。`
  if(/select|combobox|radio|checkbox/.test(kind))return `在“${name}”中选择符合本次业务的选项；选择变化可能影响后续字段，请按当前页面提示核对。`
  if(/日期|时间|截止|续期/.test(name))return `按页面提示填写或选择“${name}”，核对时间范围、续期方式及实际生效时间后再办理。`
  if(/file/.test(kind))return `按“${name}”的格式、大小及尺寸要求选择文件，核对预览后再保存；引导不会替你上传。`
  return `按当前页面的提示填写或核对“${name}”。必填标记、格式限制及校验结果以此处显示为准；引导不改变任何资料。`
}
export const subfunctionActionHelp = (label: string): string => /取消|返回|关闭/.test(label.replace(/\s+/g,''))
  ? `“${label}”用于离开或取消当前操作。未保存内容可能不会保留，请先核对；结束引导本身不会关闭业务窗口。`
  : `“${label}”是当前业务的操作入口。实际点击前请核对对象、所有字段及页面确认提示；教程只说明用途，不会触发该按钮。`
